enum iaqSensorDataChartType{
    GET_IAQ_SENSOR_DATA_CHART_START='GET_IAQ_SENSOR_DATA_CHART_START',
    GET_IAQ_SENSOR_DATA_CHART_SUCCESS = 'GET_IAQ_SENSOR_DATA_CHART_SUCCESS',
    GET_IAQ_SENSOR_DATA_CHART_ERROR = 'GET_IAQ_SENSOR_DATA_CHART_ERROR',
    RESET_IAQ_SENSOR_DATA_CHART = 'RESET_IAQ_SENSOR_DATA_CHART',
    RESET_IAQ_SENSOR_DATA_CHART_SUCCESS='RESET_IAQ_SENSOR_DATA_CHART_SUCCESS'
}

export default iaqSensorDataChartType;